import type { EventConfig } from './configTypes';

const config: EventConfig = {
  id: 'stjernekamp',
  title: 'Stjernekamp',
  description: 'Stem på din favoritt',
  imageUrl: 'https://placehold.co/600x400/EEE/31343C',
  language: 'no',
};

export default config;
